import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid2 } from '@mui/material';
import { VTKDataRefreshEmailAction  } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';

const VTKDataRefreshEmailForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();

	const handleSubmit = async () => {
		const confirmUpdate = window.confirm(`Are you sure you want to update all data?`);
		
		if (confirmUpdate) {
			try {
				const formData = new FormData();
				formData.append('UserId', userId);
				
				const data = await VTKDataRefreshEmailAction(formData); // Chama a action para excluir
				dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));
			} catch (error) {
				dispatch(enqueueSnackbar({ message: `The process has not started because an error occured. ${error}`, options: { variant: 'error' } }));
			}
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
					Update Data
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default VTKDataRefreshEmailForm;